import _defineProperty from "@babel/runtime/helpers/defineProperty";
import FeatureGates, { FeatureGateEnvironment } from '@atlassian/feature-gate-js-client';
export { FeatureGateEnvironment as StatsigEnvironment };
export class StatsigClient {
  constructor() {
    var _this = this;
    _defineProperty(this, "isStatsigInitialized", false);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _defineProperty(this, "overrides", {});
    _defineProperty(this, "getExperimentValue", function (experimentName, propertyName) {
      let defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      if (!_this.isStatsigInitialized) {
        console.warn('Statsig client not initialized.');
        return defaultValue;
      }
      if (_this.overrides[experimentName] !== undefined && _this.overrides[experimentName][propertyName] !== undefined) {
        return _this.overrides[experimentName][propertyName];
      }
      return FeatureGates.getExperimentValue(experimentName, propertyName, defaultValue);
    });
    _defineProperty(this, "checkGate", function (gateName) {
      let defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (!_this.isStatsigInitialized) {
        console.warn('Statsig client not initialized.');
        return defaultValue;
      }
      if (_this.overrides[gateName] !== undefined) {
        return Boolean(_this.overrides[gateName]);
      }
      return FeatureGates.checkGate(gateName);
    });
    _defineProperty(this, "initializeStatsigClientWithValues", async _ref => {
      let {
        marketplaceAnonymousId,
        environment,
        targetApp,
        clientSdkKey,
        experimentValues,
        customAttributes
      } = _ref;
      await FeatureGates.initializeFromValues({
        environment,
        targetApp,
        sdkKey: clientSdkKey
      }, {
        marketplaceAnonymousId
      }, customAttributes, experimentValues);
      this.isStatsigInitialized = true;
    });
    _defineProperty(this, "setOverride", overrideValues => {
      this.overrides = overrideValues;
    });
    // ---------------------- Experiments -------------------------
    _defineProperty(this, "marketplaceAppInstallAaTest", {
      showAppInstallButton: () => {
        return this.getExperimentValue('marketplace_app_install_aa_test', 'ShowAppInstallButton', true);
      }
    });
    // ---------------------- Feature Flags ----------------------
    _defineProperty(this, "enableStaffPickOnAppListing", () => {
      return this.checkGate('enable_staff_pick_on_app_listing');
    });
    _defineProperty(this, "enableAetherExperience", () => {
      return this.checkGate('enable_aether_experience');
    });
    _defineProperty(this, "showAnnouncementBannerInResourcesTab", () => {
      return this.checkGate('show_announcement_banner_in_resources_tab');
    });
    _defineProperty(this, "enableAetherSearchOverlay", () => {
      return this.checkGate('enable_aether_search_overlay');
    });
    _defineProperty(this, "enableAetherSearchEmbedded", () => {
      return this.checkGate('enable_aether_embedded_search_experience');
    });
  }
  // IMPORTANT: Calling this method will completely re-initialize the client with a new set of flags. You will need to re-render the entire page after this completes to ensure everything picks up the new flag values. You should avoid using this frequently as it has implications on the user experience.
  async initializeStatsigClient(_ref2) {
    let {
      clientKey,
      environment,
      targetApp,
      marketplaceAnonymousId
    } = _ref2;
    let customAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    try {
      await FeatureGates.initialize({
        apiKey: clientKey,
        environment,
        targetApp
      }, {
        marketplaceAnonymousId
      }, customAttributes);
      this.isStatsigInitialized = true;
    } catch (err) {
      console.error('Failed to initialize FeatureGates client.', err);
    }
  }
}
export default StatsigClient;